// ./src/components/features/ScheduleEventTypeBadge/ScheduleEventTypeBadge.tsx
import React from "react";
import { Badge } from "@mantine/core";
import { ScheduleEvent } from "@/utils";

export interface ScheduleEventTypeBadgeProps {
  event: ScheduleEvent | null | undefined;
}

export const ScheduleEventTypeBadge: React.FC<ScheduleEventTypeBadgeProps> = ({
  event,
}) => {
  const opacity = event?.isPast ? 0.6 : 1;

  if (!event) {
    return null;
  }

  if (event.id && event.recurringEventId) {
    return (
      <Badge color="orange" variant="light" size="xs" style={{ opacity }}>
        Override
      </Badge>
    );
  }

  if (!event.id && event.recurringEventId) {
    return (
      <Badge color="blue" variant="light" size="xs" style={{ opacity }}>
        Recurring
      </Badge>
    );
  }

  return (
    <Badge color="gray" variant="light" size="xs" style={{ opacity }}>
      One-time
    </Badge>
  );
};
